import "./style.css"

function LoaderLogo() {
    return (
        <div className="w-screen h-screen flex items-center justify-center">
            <div className="relative flex items-center justify-center">

                <svg
                    className="loader-logo w-[200px] h-[200px]"
                    viewBox="0 0 200 200"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient id="arc-grad" gradientUnits="userSpaceOnUse" x1="100" y1="0" x2="100" y2="200">
                            <stop offset="0%" stopColor="#4fa78b" stopOpacity="1" />
                            <stop offset="60%" stopColor="#00c07a" stopOpacity="0.5" />
                            <stop offset="100%" stopColor="#4fa78b" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                    <circle cx="100" cy="100" r="90" fill="none" stroke="#007b4e" strokeOpacity="0.12" strokeWidth="8" />
                    <path
                        d="M100,10 A90,90 0 1,1 99.9,10"
                        fill="none"
                        stroke="url(#arc-grad)"
                        strokeWidth="8"
                        strokeLinecap="round"
                    />
                </svg>

                <img
                    className="greensense-logo absolute w-[150px]"
                    src={require('../../assets/images/greensense-logo-leaf.png')}
                    alt=""
                />
            </div>
        </div>
    )
}
export default LoaderLogo;